import React, { useRef, useEffect } from 'react';
import dft from './DFT.js'
import {
  Chart,
  LineController,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
} from 'chart.js';

Chart.register(
  LineController,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
);

const FourierTransform = ({ points, width, height }) => {
  const canvasRef = useRef(null);
  // const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
  
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
  
    const chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: [],
        datasets: [
          {
            label: "Amplitude",
            data: [],
            backgroundColor: "rgba(40, 44, 52, 1)",
            borderColor:  "rgba(40, 44, 52, 1)",
            borderWidth: 1, // Increase the border width for thicker lines
            pointRadius: 0, // Set the point radius to 0 to hide the points
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          x: {
            type: "linear",
            beginAtZero: true,
            grid: {
              display: false, // This will hide the grid lines on the Y scale
            },
          },
          y: {
            type: "linear",
            beginAtZero: true,
            grid: {
              display: false, // This will hide the grid lines on the Y scale
            },
          },
        },
      },
    });
  
    const updateChart = () => {
      const X = dft(points);
  
      chart.data.labels = X.map((_, i) => i);
      chart.data.datasets[0].data = X.map((x) => x.amplitude);
      chart.update();
    };
  
    updateChart();
  
    // Return a cleanup function to destroy the chart when the component is unmounted or the points prop changes
    return () => {
      chart.destroy();
    };
  }, [points]);  

  return <canvas ref={canvasRef} width={width} height={height}/>;
};

export default FourierTransform;
